import { Injectable } from '@angular/core';
import CommonRegex from '@cropx-common/services/shared/CommonRegex';

@Injectable()
export class SharedService {
  static readonly passwordValidationRegex = CommonRegex.passwordValidationRegex;
  static readonly emailValidationRegex = CommonRegex.emailValidationRegex;
}
